<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Configurações de Single Sign-On (SSO)</h3>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            Configuração SSO
                            <ion-badge color="success">Ativo</ion-badge>
                        </ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                                    <ion-label><strong>ID:</strong> {{ item?.Id }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado em:</strong> {{ item?.CreateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado por:</strong> {{ item?.CreateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Autenticação -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="key-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Client ID:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small"
                                            (click)="toggleSSOClientIdVisibility(item)">
                                            <ion-icon
                                                [name]="item.showClientId ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showClientId">{{ item?.ClientId }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Client Secret:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleSSOSecretVisibility(item)">
                                            <ion-icon
                                                [name]="item.showSecret ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showSecret">{{ item?.ClientSecret }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de URL -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="link-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>URL de Autorização:</strong>
                                        <a href="{{item?.URLAuthorize}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLAuthorize }}</a>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="server-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>URL do Token:</strong>
                                        <a href="{{item?.URLToken}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLToken }}</a>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="list-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>URL dos Scopes do Token:</strong>
                                        <a href="{{item?.URLTokenScopes}}" target="_blank" rel="noopener noreferrer">{{
                                            item?.URLTokenScopes }}</a>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Fluxo -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="git-compare-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Grant Type:</strong> {{ item?.GrantType }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="return-down-back-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Redirect URI Callback:</strong>
                                        <a href="{{item?.RedirectUriCallback}}" target="_blank"
                                            rel="noopener noreferrer">{{ item?.RedirectUriCallback }}</a>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="arrow-redo-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Response Type:</strong> {{ item?.ResponseType }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="chatbubble-ellipses-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Prompt:</strong> {{ item?.Prompt }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Scopes -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="list-circle-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Scopes:</strong>
                                        <ion-chip *ngFor="let scope of getScopesArray(item?.Scopes)">
                                            {{ scope }}
                                        </ion-chip>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Prioridade -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="flag-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Prioridade:</strong> {{ item?.Priority }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-card-content>
                </ion-card>
            </ion-col>
            
        </ion-row>
    </ion-grid>
</ion-col>